import { render } from "./Index.vue?vue&type=template&id=c7606ede&scoped=true"
import script from "./Index.vue?vue&type=script&lang=ts"
export * from "./Index.vue?vue&type=script&lang=ts"

import "./Index.vue?vue&type=style&index=0&id=c7606ede&lang=scss&scoped=true"
script.render = render
script.__scopeId = "data-v-c7606ede"

export default script